module.exports = __webpack_public_path__ + "assets/img/case_header.9b9e50d5.jpg";